import React, { useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const ShowsCarousel = ({ shows }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % shows.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + shows.length) % shows.length);
  };

  const currentShow = shows[currentIndex];

  return (
    <section className="section-padding carousel-section" id="shows">
      <div className="container">
        <h2 className="heading-1" style={{ textAlign: 'center', marginBottom: '80px' }}>Show Offerings</h2>
        
        <div className="carousel-container">
          <button className="carousel-button carousel-button-left" onClick={prevSlide}>
            <ChevronLeft />
          </button>

          <div className="carousel-content">
            <div className="carousel-image-wrapper">
              <img 
                src={currentShow.image} 
                alt={currentShow.title} 
                className="carousel-image"
              />
            </div>
            <div className="carousel-text">
              <h3 className="hero-medium">{currentShow.title}</h3>
              <p className="body-large" style={{ marginTop: '24px', marginBottom: '32px' }}>
                {currentShow.description}
              </p>
              <div className="show-features">
                {currentShow.features.map((feature, index) => (
                  <span key={index} className="feature-badge">{feature}</span>
                ))}
              </div>
            </div>
          </div>

          <button className="carousel-button carousel-button-right" onClick={nextSlide}>
            <ChevronRight />
          </button>
        </div>

        <div className="carousel-dots">
          {shows.map((_, index) => (
            <button
              key={index}
              className={`carousel-dot ${index === currentIndex ? 'active' : ''}`}
              onClick={() => setCurrentIndex(index)}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ShowsCarousel;